<sk-modal-content
  dataTest="confirm-rename-file"
  [isHideCross]="true"
  [cancelBtnText]="'label.No' | translate"
  confirmByKeypress
  (confirmed)="confirm()"
  (cancelled)="close(false)"
  (closed)="closeWithoutResult()"
  [suppressConfirm]="!isInitCompleted"
>
  <ng-container id="sk-modal-body">
    <p>
      {{ 'text.dms.DoYouWantToRename' | translate }} <b>{{ fileName }}</b>
      {{ 'text.dms.to' | translate }} <b>{{ newFileName }}</b> ?
    </p>
    <p>{{ 'text.dms.FileAlreadyExists' | translate }}</p>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [label]="'label.Yes' | translate"
      data-test="modal-footer-confirm-button"
      (click)="confirm()">
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
